import { Link } from "@mui/material";
import styled from "styled-components";
import { theme, size, media, breakpoints } from "../../../helpers/theme";

export const PageContainer = styled.div`
padding: 20px 10px;
display: flex;
flex-direction: column;
`;
export const Container = styled.div`
width: 100%;
display: flex;
flex-direction: row;
justify-content: space-between;
align-items:stretch;

@media (max-width:${size.laptop}) {
    flex-direction: column;
    idth: 100%;
}`;
export const Zero = styled.div`
height:100%;
width: 100%;
`;
export const First = styled.div`
height:100%;
width: 31%;
padding-right:10px;
@media (max-width:${size.laptop}) {
    width: 100%;  
}`;
export const Second = styled.div`
height:100%;
width: 69%;
@media (max-width:${size.laptop}) {
    width: 100%;  
}`;
export const HedSubtitle = styled.p`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 24px;
color:${theme.colors.white};
padding:5px 12px;
background-color:${theme.colors.blue01_active};
border-radius:8px;
width: fit-content;
`;
// export const MainTitle = styled.h1`
// font-family: ${theme.fonts.interRegular};
// font-style: normal;
// font-weight: 700;
// font-size: 64px;
// line-height: 72px;
// color:${theme.colors.black_primaryText};
// margin:0px;
// @media (max-width:1310px) {
//     font-size: 54px;
//     line-height: 62px;
// }
// @media (max-width:${theme.device.laptop}px) {
//     font-size: 54px;
//     line-height: 62px;
// }`;
export const MainTitle = styled.h1`
font-family: ${theme.fonts.interRegular};
font-style: normal;
color:${theme.colors.black_primaryText};
margin:0px;
@media (max-width:${size.mobileS}) {
    font-size: 46px;
    line-height: 54px;
 }

${media.between('mobileS', 'laptopHelper')}{
    font-size: 48px;
    line-height: 64px;
}
 @media (min-width:${breakpoints.laptopHelper}px) {
    font-size: 64px;
    line-height: 72px;
 }
`;
export const Description = styled.p`
font-family: ${theme.fonts.interMedium};
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
color:${theme.colors.black_primaryText};
margin:33px 0px;
 & span{
    color:${theme.colors.blue01_active};
    text-decoration: underline;
}`;

export const StyledLink = styled(Link)`
cursor: pointer;
`;
export const AdSmallText = styled.p`
font-family: ${theme.fonts.interMedium};
font-weight: 500;
font-size: 14px;
line-height: 20px;
width: 100%;
argin-block: 0;
margin: 0px;
& span{
    white-space: nowrap;
    flex-direction: row;
    display: flex;
}
`;

export const AdSmallTextBar = styled.div`
min-width: 4px;
//height: 30px;
background: ${theme.colors.blue01_active};
border-radius: 2px;
margin-right: 24px;
`;
export const KContactBox = styled.div`
width: 100%;
display: flex;
flex-direction: row;
margin-bottom: 1rem;
`;